// Generated by purs version 0.15.15
var wheel = "wheel";
export {
    wheel
};
//# sourceMappingURL=index.js.map
